import axios from '@/utils/request';

// 获取知识目录树
export const getCatalogTree = (data: any) => {
  return axios.request({
    url: 'Course/GetCatalogTree',
    method: 'GET',
    params: data,
  });
};

// 获取课程列表
export const getCourses = (data: any) => {
  return axios.request({
    url: 'Course/GetCourses',
    method: 'GET',
    params: data,
  });
};

// 获取热门课程
export const getHotCourses = (data: any) => {
  return axios.request({
    url: 'Course/GetHotCourses',
    method: 'GET',
    params: data,
  });
};

// 获取点赞课程
export const getLikeCourses = (data: any) => {
  return axios.request({
    url: 'Course/GetLikeCourses',
    method: 'GET',
    params: data,
  });
};

// 获取我的课程
export const getMyCourses = (data: any) => {
  return axios.request({
    url: 'Course/GetMyCourses',
    method: 'GET',
    params: data,
  });
};

// 获取课程详情
export const getCourseDetails = (data: any) => {
  return axios.request({
    url: 'Course/GetCourseDetails',
    method: 'GET',
    params: data,
  });
};

// 获取课程播放详情
export const getCoursePlayDetails = (data: any) => {
  return axios.request({
    url: 'Course/GetCoursePlayDetails',
    method: 'GET',
    params: data,
  });
};

// 课程跟踪，记录学习进度
export const handlerCourseTrace = (data: any) => {
  const config: any = {
    url: 'Course/HandlerCourseTrace',
    method: 'POST',
    data,
    showLoading: false,
  };
  return axios.request(config);
};

// 获取我的积分信息
export const getMyStudyScore = (data: any) => {
  return axios.request({
    url: 'Course/getMyStudyScore',
    method: 'GET',
    params: data,
  });
};

// 积分明细记录
export const getStudyScoreDetails = (data: any) => {
  return axios.request({
    url: 'Course/getStudyScoreDetails',
    method: 'GET',
    params: data,
  });
};

// 课程播放时间
export const postSaveTime = (data: any) => {
  const config: any = {
    url: 'User/SaveTime',
    method: 'POST',
    data,
    showLoading: false,
  };
  return axios.request(config);
};
// 获取课程播放时间
export const getGetTime = (data: any) => {
  return axios.request({
    url: 'User/GetTime',
    method: 'GET',
    params: data,
  });
};

// 获取课程播放时间
export const getGetMaxTime = (data: any) => {
  return axios.request({
    url: 'User/GetMaxTime',
    method: 'GET',
    params: data,
  });
};

// 获取课程笔记
export const getMyCourseNotes = (data: any) => {
  return axios.request({
    url: 'Course/GetMyCourseNotes',
    method: 'GET',
    params: data,
  });
};



// 提交课程笔记
export const postCourseNote = (data: any) => {
  return axios.request({
    url: 'Course/PostCourseNote',
    method: 'POST',
    data,
  });
};

// 课程笔记
export const postExportCourseNote = (data: any) => {
  return axios.request({
    // 用axios发送post请求
    method: "POST",
    url: "Course/ExportNotes", // 请求地址 ，也可以传递参数
    params:data,
    responseType: "blob" // 表明返回服务器返回的数据类型

  })
};

// 删除课程笔记
export const delCourseNote = (data: any) => {
  return axios.request({
    url: 'Course/DelCourseNote',
    method: 'POST',
    params: data,
  });
};

// 获取相关课程
export const getRelatedCourses = (data: any) => {
  return axios.request({
    url: 'Course/GetRelatedCourses',
    method: 'GET',
    params: data,
  });
};

// 获取课程评价
export const getCourseEvaluation = (data: any) => {
  return axios.request({
    url: 'Course/GetCourseEvaluation',
    method: 'GET',
    params: data,
  });
};

// 提交课程评价
export const postCourseEvaluation = (data: any) => {
  return axios.request({
    url: 'Course/PostCourseEvaluation',
    method: 'POST',
    data,
  });
};

// 提交课程评价回复
export const postCourseEvaluationReply = (data: any) => {
  return axios.request({
    url: 'Course/PostCourseEvaluationReply',
    method: 'POST',
    data,
  });
};

// 提交课程讨论回复
export const postCourseDiscussReply = (data: any) => {
  return axios.request({
    url: 'Course/PostCourseDiscussReply',
    method: 'POST',
    data,
  });
};
// 获取课程讨论
export const getCourseDiscuss = (data: any) => {
  return axios.request({
    url: 'Course/GetCourseDiscuss',
    method: 'GET',
    params: data,
  });
};

// 获取课程讨论
export const getCourseFeedback = (data: any) => {
  return axios.request({
    url: 'Course/GetCourseFeedback',
    method: 'GET',
    params: data,
  });
};

// 提交课程讨论
export const postCourseDiscuss = (data: any) => {
  return axios.request({
    url: 'Course/PostCourseDiscuss',
    method: 'POST',
    data,
  });
};

// 提交课程反馈
export const postCourseFeedback = (data: any) => {
  return axios.request({
    url: 'Course/PostCourseFeedback',
    method: 'POST',
    data,
  });
};


// 获取课程讨论
export const getCreditRatings = (data: any) => {
  return axios.request({
    url: 'Course/getCreditRatings',
    method: 'GET',
    params: data,
  });
};

// 获取积分规则
export const getYears = (data: any) => {
  return axios.request({
    url: 'Course/GetScoreRules',
    method: 'GET',
    params: data,
  });
};
